

import { prePatchedFetch } from "./hooks";
import type { ICartApi, ShopifyCartAddInput, ShopifyCartAddOutput, ShopifyCartChangeInput, ShopifyCartData, ShopifyCartItemData, ShopifyCartUpdateInput } from "./types/ICartApi";

export class CartApi implements ICartApi {

  private post<Output>(url: string, data?: object): Promise<Output> {

    const reqInit: RequestInit = {
      method: "post"
      
    }
    if(data) {
      reqInit.headers = {
        "Content-Type": "application/json",
      }
      reqInit.body = JSON.stringify(data);
    }

    return prePatchedFetch(url, reqInit).then(res => res.json() as Promise<Output>);
  }

  private get<Output>(url: string): Promise<Output> {
    return prePatchedFetch(url).then(res => res.json() as Promise<Output>);
  }

  async cartAdd({ items }: ShopifyCartAddInput): Promise<ShopifyCartAddOutput> {
    return this.post<{
      items: ShopifyCartItemData[];
    }>("/cart/add.js", { items });
  }
  async cartUpdate(data: ShopifyCartUpdateInput): Promise<ShopifyCartData> {
    return this.post<ShopifyCartData>("/cart/update.js", data);
  }
  async cartChange(data: ShopifyCartChangeInput): Promise<ShopifyCartData> {
    return this.post<ShopifyCartData>("/cart/change.js", data);
  }

  async cartGet(): Promise<ShopifyCartData> {
    return this.get<ShopifyCartData>("/cart.js");
  }

  async cartClear(): Promise<ShopifyCartData> {
    return this.post<ShopifyCartData>("/cart/clear.js");
  }

}